import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import "normalize.css";

import { auto } from "browser-unhandled-rejection";

auto();
